// extracted by mini-css-extract-plugin
export default {"login":"style_login__FkpNz","login__buttons":"style_login__buttons__IJ0c2"};